import { getSignupUrl } from '~utils/external_links';

angular.module('wbControllers').controller('BannerController',

  ['$scope', '$rootScope', '$window', 'users', 'sharedLinks', 'locale',
    function ($scope, $rootScope, $window, users, sharedLinks, locale) {
      $scope.currentLocation = $window.location;
      $scope.showMenu = false;
      $scope.bannerLinks = sharedLinks.banner;

      $scope.bannerTheme = function () {
        const lightText = [
          '/portfolios',
          '/team',
          '/logged-out',
          '/security',
        ];

        const darkText = [
          '/pricing',
        ];

        const location = function(location) {
          const locationMatch = new RegExp(`^${location}`);
          return $scope.currentLocation.pathname.match(locationMatch);
        };

        if (lightText.some(location)) {
          return 'light-text';
        } else if (darkText.some(location)) {
          return 'dark-text';
        }
      };

      $scope.atLocation = location => $scope.currentLocation.pathname.match(location);

      $scope.$on('$locationChangeStart', () => $scope.showMenu = false);

      $scope.navToggle = function () {
        $scope.showMenu = !$scope.showMenu;
        if ($scope.showMenu) {
          document.getElementById('banner').dataset.collapsed = false;
          document.getElementById('banner').style.position = 'fixed';
          document.body.style.height = '0px';
          document.body.style.overflow = 'hidden';
        } else {
          document.body.removeAttribute('style');
          document.getElementById('banner').dataset.collapsed = true;
          document.getElementById('banner').style.position = 'relative';
        }
      };

      angular.element($window).bind('resize', function () {
        if ($window.matchMedia('(min-width: 48rem)').matches && $scope.showMenu){
          $scope.navToggle();
        }
      });

      $scope.sendEmailConfirmation = function () {
        return users.sendEmailConfirmation().then(() => document.getElementById('flash_email_confirmation').style.display = 'none');
      };

      $scope.setLanguage = language => locale.setLanguage(language, true);

      $scope.language = () => locale.getCurrentLanguage();
      $scope.isFrench = () => locale.isFrench();

      $scope.isRenderableLink = function (link) {
        return (!users.hasRole(link.excludeRole) && users.hasRole(link.role) && link.enabled !== 'false');
      };

      $scope.signupUrl = () => getSignupUrl($scope.language());
    },
  ]);
